module.exports = __webpack_public_path__ + "static/media/albert.6f568414.jpg";